<template>
    <div class="horse-edit-documents flex w-full gap-5 h-full">
        <div class="flex w-full flex-column gap-5">
            <h2 class="page-header">{{ $t('message.horseEdit.documents.header') }} ({{ horse.name }})</h2>
            <HorseEditDocumentsTable v-if="loading" :horse="horse" :documents="documents"/>
            <HorseEditDocumentsGenerate :horse="horse" @document-generated="addDocument"/>
        </div>
        <HorseEditDocumentQRCodes :horse="horse"/>
    </div>
</template>

<script>
import Button from "primevue/button";
import Toolbar from "primevue/toolbar";
import {Form} from "vee-validate";
import QrcodeVue, { QrcodeCanvas, QrcodeSvg } from "qrcode.vue";
import CustomInputText from "../../../../components/form/CustomInputText.vue";
import LibyanOrnament from "@/components/LibyanOrnament.vue";
import HorseListSearchCriteria
    from "@/views/horse/horseList/components/HorseListSearchCriteria.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomIconButton from "@/components/form/CustomIconButton.vue";
import HorseTable from "@/views/horse/horseList/components/HorseTable.vue";
import HorsePreview from "@/views/horse/horseList/components/HorsePreview.vue";
import CustomTextButton from "@/components/form/CustomTextButton.vue";
import HorseEditDocumentQRCodes
    from "@/views/horse/horseEdit/documents/components/HorseEditDocumentsQRCodes.vue";
import HorseEditDocumentsTable
    from "@/views/horse/horseEdit/documents/components/HorseEditDocumentsTable.vue";
import HorseEditDocumentsGenerate
    from "@/views/horse/horseEdit/documents/components/HorseEditDocumentsGenerate.vue";
import {getHorseDocuments} from "@/swagger/vue-api-client";

export default {
    name: "HorseEditDocumentsView",

    components: {
        HorseEditDocumentsGenerate,
        HorseEditDocumentsTable,
        HorseEditDocumentQRCodes,
        CustomTextButton,
        HorsePreview,
        HorseTable,
        CustomIconButton,
        CustomButton,
        HorseListSearchCriteria,
        LibyanOrnament,
        Button,
        Toolbar,
        CustomInputText,
        Form,
        QrcodeVue,
        QrcodeCanvas,
        QrcodeSvg,
    },

    props: {
        horse: null,
    },

    data() {
        return {
            documents: [],
            loading: false,
            qr_value: "https://example.com",
            qr_size: 200,
        };
    },

    beforeMount() {
        getHorseDocuments({horseId: this.horse.id}).then((res) => {
            this.documents = res.data;
        });
        this.loading = true;
    },

    methods: {
        addDocument(newDoc) {
            this.documents.push(newDoc);
        },
    },
};
</script>

<style lang="scss" scoped>
    .horse-edit-documents {
        .page-header {
            color: var(--accent-color);
            font-weight: 500;
            font-size: 35px;
            font-family: var(--decor-font-family);
        }
    }
</style>
